import React, {memo} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';

const PreviewColumn = memo(({product}) => {

  return (
    <td className={'text-center'}>
      <img style={{maxWidth: '128px', maxHeight: '128px'}} className={classNames({
        'product-image-detail': true,
        'img-blackwhite': !product.status,
      })} alt="" src={product.renderedImage?.url}/>
    </td>
  );
});

PreviewColumn.propTypes = {
  product: PropTypes.object.isRequired,
};

export default PreviewColumn;
